import { CookieConsent } from "./components/CookieConsent";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { initializeGA, trackPageView } from "./hooks/useAnalytics";
import { useState, useCallback, useEffect, lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import styled from "styled-components";

// Lazy load pages for better code splitting
const HomePage = lazy(() => import("./pages/HomePage"));
const DocsPage = lazy(() => import("./pages/DocsPage"));

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Main = styled.main`
  flex: 1;
`;

const LoadingFallback = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 90vh;
  color: var(--text-secondary);
`;

function AppContent() {
  // Initialize analyticsEnabled based on existing consent
  const [analyticsEnabled, setAnalyticsEnabled] = useState(() => {
    return localStorage.getItem("kuack_consent") === "accepted";
  });
  const location = useLocation();

  const handleConsentAccept = useCallback(() => {
    initializeGA();
    setAnalyticsEnabled(true);
  }, []);

  const handleConsentReject = useCallback(() => {
    setAnalyticsEnabled(false);
  }, []);

  // Track page views on route changes
  useEffect(() => {
    if (analyticsEnabled) {
      const path = location.pathname;
      const title = document.title || path;
      trackPageView(path, title);
    }
  }, [location.pathname, analyticsEnabled]);

  return (
    <AppContainer>
      <Header />
      <Main>
        <Suspense fallback={<LoadingFallback>Loading...</LoadingFallback>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/docs/*" element={<DocsPage />} />
          </Routes>
        </Suspense>
      </Main>
      <Footer />
      <CookieConsent onAccept={handleConsentAccept} onReject={handleConsentReject} />
    </AppContainer>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
